// Delay snap scroll so that it doesn't collide with the initial slide in animation
window.addEventListener('DOMContentLoaded', (event) => {
  setTimeout(() => {
    document.querySelector('.extras-edition-cards').classList.add('extras-edition-cards--snap-scroll');
  }, 750);
});
